import { INeoAction } from './../Actions.interface';
import { CUSTOMER_LIST_ACTIONS, REQUEST_ACTIONS, STATUS } from '../../Constants/Actions.constants';
import { isActionValid } from '../../Helpers/Reducer.helper';
import { Customer } from '../../Models/DTO/Customer.model';
import { CustomerTag } from '~/Models/DTO/Tag.model';
import { IBookingSimple } from '~/Models/DTO/Booking.models';

export interface CustomerListState {
  customers: Customer[];
  totalCustomers: number;
  pageSize: number;
  currentPage: number;
  totalPages: number;
}

const useValidActions = isActionValid([
  REQUEST_ACTIONS.CUSTOMER_LIST,
  CUSTOMER_LIST_ACTIONS.SELECT_CUSTOMER,
]);

const INITAL_STATE: CustomerListState = {
  customers: [],
  totalCustomers: 0,
  pageSize: 30,
  currentPage: 1,
  totalPages: 1,
};

const mergeCustomers = (currentList: Customer[], newList: Customer[], newPage: number = -1) => {
  // delete any old customers on this page #EXPEREMENTAL
  const updatedCurrentList = currentList.filter((customer) => customer.pageNumber !== newPage);
  const currentCustomerIds = updatedCurrentList.map((customer) => customer.uuid);
  const uniqueNewCustomers = newList
    .filter((newCustomer) => !currentCustomerIds.includes(newCustomer.uuid))
    .map((newCustomer) => {
      newCustomer.pageNumber = newPage;
      return newCustomer;
    });
  return updatedCurrentList.concat(uniqueNewCustomers);
};

const mergeTagsToCustomers = (currentList: Customer[], tagList: CustomerTag[]): Customer[] =>
  currentList.map((oldCustomer) => ({
    ...oldCustomer,
    tags: tagList.filter((tag) => tag.customerId === oldCustomer.id) || oldCustomer?.tags,
  })) || {};

export default (state = INITAL_STATE, action: INeoAction): CustomerListState => {
  const { name, payload, status, type, request } = action;

  const actionValid = useValidActions(name || type);
  if (status === STATUS.SUCCESS) {
    if (name === REQUEST_ACTIONS.CUSTOMER_LIST) {
      return {
        ...state,
        customers: mergeCustomers(state.customers, payload, request.page),
        pageSize: payload.length,
        currentPage: request.page,
      };
    } else if (name === REQUEST_ACTIONS.BOOKING_LIST) {
      return {
        ...state,
        customers: mergeCustomers(
          state.customers,
          payload.map((booking: IBookingSimple) => booking.customer),
        ),
      };
    } else if (name === REQUEST_ACTIONS.CUSTOMER_TAGS) {
      return {
        ...state,
        customers: mergeTagsToCustomers(state.customers, payload),
      };
    } else if (actionValid) {
      return {
        ...state,
        customers: payload,
      };
    }

    if (name === REQUEST_ACTIONS.SINGLE_CUSTOMER) {
      return {
        ...state,
        customers: mergeCustomers(state.customers, [payload]),
      };
    }
  }

  return state;
};
